<ng-container *ngIf="poll">
  <tyt-poll [mini]="true" [poll]="poll"></tyt-poll>
</ng-container>